export default __webpack_public_path__ + "static/media/15.ae492682.jpg";